import React from "react";
import GATSBY_COMPILED_MDX from "/home/runner/work/WorthyD-worthyd.com/WorthyD-worthyd.com/content/blog/2012/08/infinite-playlist-my-top-10-console-games-that-never-get-old.md";
import PostTemplate from './index';
const TemplateComponent = PostTemplate;
const PostTemplateQuery = "842063436";
TemplateComponent
export default function GatsbyMDXWrapper(props) {
  return React.createElement(TemplateComponent, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export {Head} from './index';
